<template>
    <div>
        <div v-for="ticketCategory in this.ticketCategories">
            <div class="card mb-4">
                <div class="card-header">
                    <div class="row">
                        <div class="col-6">
                            <h3 class="pull-left">
                                <strong>{{ trans.get('checkout.delivery') }}</strong>
                            </h3>
                        </div>
                        <div class="col-6">
                            <div class="text-right">
                                <i>
                                    <small>{{ ticketCategory.product.name }} - {{ ticketCategory.name }}</small>
                                </i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="col-12 radio-block">
                        <div v-for="deliveryMethod in ticketCategory.delivery_methods" class="col-12 radio-block">
                            <div class="block pb-2">
                                <div class="checkbox">
                                    <label class="customradio"
                                           :for="deliveryLabel(deliveryMethod, ticketCategory)">
                                        <span class="radiotextsty">{{ deliveryMethod.name }}</span>
                                        <input :disabled="loading" type="radio"
                                               :data-checked="setChecked(deliveryMethod, ticketCategory)"
                                               :name="'ticket' + ticketCategory.id"
                                               :id="deliveryLabel(deliveryMethod, ticketCategory)"
                                               :value="deliveryMethod.id"
                                               v-model="delivery_method_id[ticketCategory.id]"
                                               @change="setDelivery(deliveryMethod, ticketCategory)"
                                               :class="getClass"
                                               class="ticket_delivery_selector js-delivery-radio">
                                        <span class="checkmark"></span>
                                    </label>
                                    <a class="w-auto infolink btn btn-red btn-sm btn-block js-delivery-details"
                                       :data-ticket-category-id="ticketCategory.id"
                                       :data-type=" deliveryMethod.key"
                                       href="#">
                                        {{ trans.get('checkout.details') }}
                                    </a>
                                </div>
                            </div>
                            <fieldset class="info_delivery delivery_form"
                                      :data-delivery="deliveryInfoLabel(ticketCategory, deliveryMethod)">
                                <div class="delivery_info"
                                     :class="deliveryInfoLabel(ticketCategory, deliveryMethod)"
                                     style="display:none;">
                                    <div class="lightbox_content" v-html="deliveryMethod.details">
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapFields} from 'vuex-map-fields';

    export default {
        name:     'product-delivery',
        props:    [],
        data() {
            return {
                checked_delivery_methods: {},
            };
        },
        methods:  {
            deliveryLabel(deliveryMethod, ticketCategory) {
                return 'delivery-' + deliveryMethod.key + '_' + ticketCategory.id + '_' + deliveryMethod.id;
            },
            setChecked(deliveryMethod, ticketCategory) {
                if (this.delivery_method_id[ticketCategory.id] === deliveryMethod.id) {
                    this.setDeliveryMethod(deliveryMethod, ticketCategory);
                } else if (ticketCategory.delivery_methods.length === 1) {
                    this.delivery_method_id[ticketCategory.id] = deliveryMethod.id;
                    this.setDeliveryMethod(deliveryMethod, ticketCategory);
                }
            },
            setDelivery(deliveryMethod, ticketCategory) {
                this.setDeliveryMethod(deliveryMethod, ticketCategory);
            },
            deliveryInfoLabel(ticketCategory, deliveryMethod) {
                return ticketCategory.id + '_' + deliveryMethod.key;
            },
            getClass(deliveryMethod) {
                let data = [];
                data['requires_delivery'] = deliveryMethod.requires_delivery;
                data[deliveryMethod.key] = 1;
                return data;
            },
            setDeliveryMethod(deliveryMethod, ticketCategory) {
                this.checked_delivery_methods[ticketCategory.id] = deliveryMethod;
            },
            processDelivery() {
                var self = this;
                this.deliveryTotal = 0;
                this.requires_delivery = false;
                Object.entries(this.checked_delivery_methods).map(function ([ticketCategoryId, deliveryMethod]) {
                    if(!self.delivery_method_id[ticketCategoryId]){
                        return;
                    }
                    self.deliveryTotal += parseFloat(deliveryMethod.sale_price);
                    if (deliveryMethod.requires_delivery) {
                        self.requires_delivery = deliveryMethod.requires_delivery
                    }
                });
                self.cartTotal = self.deliveryTotal + self.subTotal;
            }
        },
        computed: {
            ...mapFields([
                             'ticketCategories',
                             'deliveryTotal',
                             'cartTotal',
                             'subTotal',
                             'loading',
                             'order.requires_delivery',
                             'order.delivery_method_id',
                         ]),
            isValid() {
                return Object.keys(this.delivery_method_id).length;
            },
        },
        watch:    {
            delivery_method_id : {
                handler() {
                    this.processDelivery();
                },
                deep: true,
                immediate: true,
            }
        },
        mounted() {
        },

    }

</script>
